<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows Hardship Withdrawals?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.allow_hardship_withdrawals_yesno"
            >
              <roe-radio-input
                v-model="formData.allow_hardship_withdrawals_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div
          v-if="showHardshipFromMatch"
          class="form-row form-row--center-small"
        >
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows Hardship Withdrawals FROM ELECTIVE
              DEFERRALS?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.hardship_from_elective_deferrals_yesno"
            >
              <roe-radio-input
                v-model="formData.hardship_from_elective_deferrals_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows Hardship Withdrawals FROM EMPLOYER
              MATCH FUNDS?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.hardship_from_match_any_yesno"
            >
              <roe-radio-input
                v-model="formData.hardship_from_match_any_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row" v-if="showHardshipEmployerMatch">
          <div class="form-unit">
            <div class="light-label">
              Hardship Withdrawals from employer match funds
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.hardship_withdrawals_employer_match"
            >
              <v-select
                v-model="formData.hardship_withdrawals_employer_match"
                name="hardship_withdrawals_employer_match"
                :options="[
                  { code: 1, label: 'Yes, Vested Portion' },
                  { code: 2, label: 'Yes, Full Account Balance' }
                ]"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows Hardship Withdrawals FROM EMPLOYER
              OTHER CONTRIBUTIONS?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.hardship_from_profit_sharing_any_yesno"
            >
              <roe-radio-input
                v-model="formData.hardship_from_profit_sharing_any_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row" v-if="showHardshipEmployerOther">
          <div class="form-unit">
            <div class="light-label">
              Hardship Withdrawals from employer other contributions
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.hardship_withdrawals_employer_other"
            >
              <v-select
                v-model="formData.hardship_withdrawals_employer_other"
                name="hardship_withdrawals_employer_other"
                :options="[
                  { code: 1, label: 'Yes, Vested Portion' },
                  { code: 2, label: 'Yes, Full Account Balance' }
                ]"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Does the plan allow In-Service Withdrawals after age 59 ½:
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.in_service_withdrawals_elective_deferrals"
            >
              <roe-radio-input
                v-model="formData.in_service_withdrawals_elective_deferrals"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <template v-if="showInService">
          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="common-label">
                Indicate if the plan allows In-Service Withdrawals from EMPLOYER
                MATCH CONTRIBUTIONS?
              </div>
            </div>
            <div class="form-unit">
              <roe-error-message
                :field="$v.formData.in_service_withdrawals_employer_match_yesno"
              >
                <roe-radio-input
                  v-model="formData.in_service_withdrawals_employer_match_yesno"
                ></roe-radio-input>
              </roe-error-message>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                In-Service Withdrawals from employer match contributions
              </div>
            </div>
            <div class="form-unit">
              <roe-error-message
                v-if="showInServiceEmployerMatch"
                :field="$v.formData.in_service_withdrawals_employer_match"
              >
                <v-select
                  v-model="formData.in_service_withdrawals_employer_match"
                  name="in_service_withdrawals_employer_match"
                  :options="[
                    { code: 1, label: 'Yes, Vested Portion' },
                    { code: 2, label: 'Yes, Full Account Balance' }
                  ]"
                  :reduce="label => label.code"
                  required
                >
                </v-select>
              </roe-error-message>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row">
            <div class="form-unit">
              <div class="common-label">
                Indicate if the plan allows In-Service Withdrawals from EMPLOYER
                OTHER CONTRIBUTIONS?
              </div>
            </div>
            <div class="form-unit">
              <roe-error-message
                :field="$v.formData.in_service_withdrawals_employer_other_yesno"
              >
                <roe-radio-input
                  v-model="formData.in_service_withdrawals_employer_other_yesno"
                ></roe-radio-input>
              </roe-error-message>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                In-Service Withdrawals from employer other contributions
              </div>
            </div>
            <div class="form-unit">
              <roe-error-message
                v-if="showInServiceEmployerOther"
                :field="$v.formData.in_service_withdrawals_employer_other"
              >
                <v-select
                  v-model="formData.in_service_withdrawals_employer_other"
                  name="in_service_withdrawals_employer_other"
                  :options="[
                    { code: 1, label: 'Yes, Vested Portion' },
                    { code: 2, label: 'Yes, Full Account Balance' }
                  ]"
                  :reduce="label => label.code"
                  required
                >
                </v-select>
              </roe-error-message>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row-devider"></div>

          <div class="form-row form-row--center-small">
            <div class="form-unit">
              <div class="common-label">
                Indicate if the plan provides a Financial Wellness Program?
              </div>
            </div>
            <div class="form-unit">
              <roe-error-message :field="$v.formData.financial_wellness_exists">
                <roe-radio-input
                  v-model="formData.financial_wellness_exists"
                ></roe-radio-input>
              </roe-error-message>
            </div>
            <div class="form-unit"></div>
          </div>

          <template v-if="showFinancialWellness">
            <div class="form-row form-row--center-small">
              <div class="form-unit">
                <div class="light-label">
                  Name of Financial Wellness Program Provider
                </div>
              </div>
              <div class="form-unit">
                <roe-error-message
                  :field="$v.formData.financial_wellness_provider"
                >
                  <input
                    type="text"
                    v-model="formData.financial_wellness_provider"
                    name="financial_wellness_provider"
                    required
                    maxlength="60"
                  />
                </roe-error-message>
              </div>
              <div class="form-unit"></div>
            </div>

            <div class="form-row form-row--center-small">
              <div class="form-unit">
                <div class="light-label">
                  Indicate an annual cost for Financial Wellness Service:
                </div>
              </div>
              <div class="form-unit">
                <roe-error-message
                  :field="$v.formData.annual_cost_financial_wellness_service"
                >
                  <input
                    type="number"
                    v-model="formData.annual_cost_financial_wellness_service"
                    name="annual_cost_financial_wellness_service"
                    required
                    min="1"
                    max="9999999999"
                  />
                </roe-error-message>
              </div>
              <div class="form-unit"></div>
            </div>
          </template>
        </template>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan provides a Transition Assistance Program?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.transition_assistance_exists"
            >
              <roe-radio-input
                v-model="formData.transition_assistance_exists"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <template v-if="showTransitionAssistance">
          <div class="form-row form-row--center-small">
            <div class="form-unit">
              <div class="light-label">
                Name of Transition Assistance Program Provider
              </div>
            </div>
            <div class="form-unit">
              <roe-error-message
                :field="$v.formData.transition_assistance_provider"
              >
                <input
                  type="text"
                  v-model="formData.transition_assistance_provider"
                  name="transition_assistance_provider"
                  required
                  maxlength="60"
                />
              </roe-error-message>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row form-row--center-small">
            <div class="form-unit">
              <div class="light-label">
                Indicate an annual cost for Transition Assistance Service:
              </div>
            </div>
            <div class="form-unit">
              <roe-error-message
                :field="$v.formData.annual_cost_transition_assistance_service"
              >
                <input
                  type="text"
                  v-model.number="
                    formData.annual_cost_transition_assistance_service
                  "
                  name="annual_cost_transition_assistance_service"
                  required
                  min="1"
                  max="9999999999"
                />
              </roe-error-message>
            </div>
            <div class="form-unit"></div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { mapMutations } from "vuex";
import {
  RESET_ATTRIBUTES,
  SET_INVALID_FORM_STATE
} from "@/store/mutations.type";
import {
  required,
  minValue,
  maxValue,
  maxLength,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "RoeWithdrawalsForm",
  props: ["formData"],
  created() {
    this.setNextButtonState({ isInvalid: this.$v.$invalid });
  },
  watch: {
    "$v.$invalid": function(value) {
      this.setNextButtonState({ isInvalid: value });
    },
    "formData.allow_hardship_withdrawals_yesno": function() {
      this.resetAttributes("allow_hardship_withdrawals_yesno");
    },
    "formData.hardship_from_match_any_yesno": function() {
      this.resetAttributes("hardship_from_match_any_yesno");
    },
    "formData.hardship_from_profit_sharing_any_yesno": function() {
      this.resetAttributes("hardship_from_profit_sharing_any_yesno");
    },
    "formData.in_service_withdrawals_elective_deferrals": function() {
      this.resetAttributes("in_service_withdrawals_elective_deferrals");
    },
    "formData.in_service_withdrawals_employer_match_yesno": function() {
      this.resetAttributes("in_service_withdrawals_employer_match_yesno");
    },
    "formData.in_service_withdrawals_employer_other_yesno": function() {
      this.resetAttributes("in_service_withdrawals_employer_other_yesno");
    },
    "formData.financial_wellness_exists": function() {
      this.resetAttributes("financial_wellness_exists");
    },
    "formData.transition_assistance_exists": function() {
      this.resetAttributes("transition_assistance_exists");
    }
  },
  validations() {
    return {
      formData: {
        allow_hardship_withdrawals_yesno: { required },
        hardship_from_match_any_yesno: {
          required: requiredIf(() => this.showHardshipFromMatch)
        },
        hardship_withdrawals_employer_match: {
          required: requiredIf(() => this.showHardshipEmployerMatch)
        },
        hardship_from_profit_sharing_any_yesno: {
          required: requiredIf(() => this.showHardshipFromMatch)
        },
        hardship_withdrawals_employer_other: {
          required: requiredIf(() => this.showHardshipEmployerOther)
        },
        in_service_withdrawals_elective_deferrals: { required },
        in_service_withdrawals_employer_match_yesno: {
          required: requiredIf(() => this.showInService)
        },
        in_service_withdrawals_employer_match: {
          required: requiredIf(() => this.showInServiceEmployerMatch)
        },
        in_service_withdrawals_employer_other_yesno: {
          required: requiredIf(() => this.showInService)
        },
        in_service_withdrawals_employer_other: {
          required: requiredIf(() => this.showInServiceEmployerOther)
        },
        financial_wellness_exists: {
          required: requiredIf(() => this.showInService)
        },
        financial_wellness_provider: {
          required: requiredIf(() => this.showFinancialWellness),
          maxLength: maxLength(60)
        },
        annual_cost_financial_wellness_service: {
          required: requiredIf(() => this.showFinancialWellness),
          minValue: minValue(0),
          maxValue: maxValue(9999999999)
        },
        transition_assistance_exists: { required },
        transition_assistance_provider: {
          required: requiredIf(() => this.showTransitionAssistance),
          maxLength: maxLength(60)
        },
        annual_cost_transition_assistance_service: {
          required: requiredIf(() => this.showTransitionAssistance),
          minValue: minValue(0),
          maxValue: maxValue(9999999999)
        }
      }
    };
  },
  computed: {
    showHardshipFromMatch() {
      return +this.formData.allow_hardship_withdrawals_yesno === 1;
    },
    showHardshipEmployerMatch() {
      return +this.formData.hardship_from_match_any_yesno === 1;
    },
    showHardshipEmployerOther() {
      return +this.formData.hardship_from_profit_sharing_any_yesno === 1;
    },
    showInService() {
      return +this.formData.in_service_withdrawals_elective_deferrals === 1;
    },
    showInServiceEmployerMatch() {
      return +this.formData.in_service_withdrawals_employer_match_yesno === 1;
    },
    showInServiceEmployerOther() {
      return +this.formData.in_service_withdrawals_employer_other_yesno === 1;
    },
    showFinancialWellness() {
      return +this.formData.financial_wellness_exists === 1;
    },
    showTransitionAssistance() {
      return +this.formData.transition_assistance_exists === 1;
    }
  },
  components: {
    RoeErrorMessage,
    RoeRadioInput
  },
  methods: {
    ...mapMutations({
      resetAttributes: RESET_ATTRIBUTES,
      setNextButtonState: SET_INVALID_FORM_STATE
    })
  }
};
</script>
